"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaypointType = exports.Network = exports.individual = void 0;
exports.individual = 'individual';
var Network;
(function (Network) {
    Network["Conventional"] = "conventional";
    Network["SingleWagon"] = "single-wagon";
    Network["SystemTrain"] = "system-train";
    Network["Continental"] = "continental";
    Network["Maritime"] = "maritime";
    Network["Eurasia"] = "eurasia";
    Network["Wagonload"] = "wagonload";
    Network["Intermodal"] = "intermodal";
    Network["RollingRoad"] = "rolling-road";
    Network["All"] = "all";
})(Network = exports.Network || (exports.Network = {}));
var WaypointType;
(function (WaypointType) {
    WaypointType["Station"] = "station";
    WaypointType["Vertex"] = "vertex";
    WaypointType["Individual"] = "individual";
})(WaypointType = exports.WaypointType || (exports.WaypointType = {}));
